import React, { useState, useEffect } from 'react';
import { Typography, Paper, TextField, Button, Box, FormControlLabel, Switch, Divider } from '@mui/material';
import { useSnackbar } from 'notistack';
import axiosInstance from '../utils/axios'; // Импортируем настроенный axiosInstance

const Settings = () => {
  const [settings, setSettings] = useState({
    siteName: '',
    megaLogin: '',
    megaPassword: '',
    marketplace_sync_enabled: 'false'
  });
  const { enqueueSnackbar } = useSnackbar();

  const fields = [
    { name: 'siteName', label: 'Название сайта', type: 'text' },
    { name: 'megaLogin', label: 'Логин Mega', type: 'text' },
    { name: 'megaPassword', label: 'Пароль Mega', type: 'text' }
  ];

  // Загружаем текущие настройки с сервера
  useEffect(() => {
    axiosInstance.get('/settings')
      .then((response) => {
        // Заполняем состояние настройками с сервера
        setSettings(response.data);
      })
      .catch((error) => {
        console.error('Ошибка при получении настроек:', error);
      });
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setSettings((prevSettings) => ({
      ...prevSettings,
      [name]: value
    }));
  };

  const handleSave = (name) => {
    const value = settings[name];
    // Отправляем обновленную настройку на сервер
    axiosInstance.put(`/settings/${name}`, { value })
      .then(() => {
        enqueueSnackbar(`${name} сохранено`, { variant: 'success' });
      })
      .catch((error) => {
        enqueueSnackbar(`Ошибка при сохранении ${name}`, { variant: 'error' });
        console.error('Ошибка при сохранении:', error);
      });
  };

  const handleSyncToggle = (checked) => {
    const value = checked ? 'true' : 'false';
    setSettings((prev) => ({ ...prev, marketplace_sync_enabled: value }));
    
    axiosInstance.put('/settings/marketplace_sync_enabled', { value })
      .then(() => {
        enqueueSnackbar(
          checked 
            ? 'Синхронизация с маркетплейсом включена' 
            : 'Синхронизация с маркетплейсом выключена',
          { variant: 'success' }
        );
      })
      .catch((error) => {
        enqueueSnackbar('Ошибка при изменении настройки синхронизации', { variant: 'error' });
        console.error('Ошибка при изменении синхронизации:', error);
        // Откатываем изменение при ошибке
        setSettings((prev) => ({ ...prev, marketplace_sync_enabled: checked ? 'false' : 'true' }));
      });
  };

  return (
    <Paper sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        Настройки
      </Typography>

      {/* Синхронизация с маркетплейсом */}
      <Box sx={{ mb: 3 }}>
        <Typography variant="h6" gutterBottom>
          Интеграция с маркетплейсом
        </Typography>
        <FormControlLabel
          control={
            <Switch
              checked={settings.marketplace_sync_enabled === 'true'}
              onChange={(e) => handleSyncToggle(e.target.checked)}
              color="primary"
            />
          }
          label="Синхронизация с маркетплейсом"
        />
        <Typography variant="body2" color="text.secondary" sx={{ ml: 4, mt: 1 }}>
          При включении все изменения (города, районы, товары, фасовки, курьеры, адреса) будут автоматически синхронизироваться с маркетплейсом. 
          Если синхронизация включена и маркетплейс недоступен, вы получите сообщение об ошибке.
        </Typography>
      </Box>

      <Divider sx={{ my: 3 }} />

      <Typography variant="h6" gutterBottom>
        Общие настройки
      </Typography>

      {fields.map((field) => (
        <Box key={field.name} sx={{ mb: 2 }}>
          <Typography variant="body1" gutterBottom>
            {field.label}
          </Typography>
          <TextField
            label={field.label}
            fullWidth
            type={field.type}
            name={field.name}
            value={settings[field.name]}
            onChange={handleChange}
          />
          <Button
            variant="contained"
            color="primary"
            onClick={() => handleSave(field.name)} // Сохраняем конкретное поле
            sx={{ mt: 1 }}
          >
            Сохранить {field.label}
          </Button>
        </Box>
      ))}
    </Paper>
  );
};

export default Settings;
